import React from 'react'
import './AdminHeader.css'
import { NavLink } from 'react-router-dom'

const AdminHeader = () => {
    return (
        <div>
            <nav data-bs-theme="dark" className="header_cont navbar navbar-expand navbar-light sticky-top">
                <div className="container">
                    <span className="navbar-brand">
                        <NavLink to="/" className="header_logo navbar-brand"><img src="/Images/ShopLogo.svg" alt="Shopsaverz Logo" b-upmkfl37bn="" /></NavLink>
                    </span>

                    <div className="justify-content-end navbar-nav"><a className="nav-link " style={{ color: "black" }}>Hello superadmin !</a>
                        <a role="button" className="logout_div nav-link" style={{ color: "black" }}>   Logout</a></div></div></nav>

        </div>
    )
}

export default AdminHeader
